import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';

// Visual style shared by every text input, select and textarea. Width and padding stay
// with each page (`<Input className="w-1/2 px-3 py-2" />`) so layouts don't fight this.
export const controlClass = cn(
    'rounded-lg border border-slate-300 bg-white text-sm text-slate-900 shadow-sm',
    'transition-colors placeholder:text-slate-400',
    'focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20',
    'disabled:cursor-not-allowed disabled:opacity-60',
    'dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:placeholder:text-slate-500',
    'dark:focus:border-brand-400 dark:focus:ring-brand-400/20'
);

export function Label({ className, children, ...props }) {
    return (
        <label className={cn('mb-1.5 block text-sm font-medium text-slate-700 dark:text-slate-300', className)} {...props}>
            {children}
        </label>
    );
}

export const Input = forwardRef(function Input({ className, ...props }, ref) {
    return <input ref={ref} className={cn(controlClass, className)} {...props} />;
});

export const Select = forwardRef(function Select({ className, children, ...props }, ref) {
    return (
        <select ref={ref} className={cn(controlClass, className)} {...props}>
            {children}
        </select>
    );
});

export const Textarea = forwardRef(function Textarea({ className, ...props }, ref) {
    return <textarea ref={ref} className={cn(controlClass, className)} {...props} />;
});
